module.exports = __webpack_public_path__ + "media/frontend/base/typo/fonts/NeoSansPro-Regular-print-cea7f673cab7033846b3c7fcd4cc9430.ttf";